module.exports = __webpack_public_path__ + "img/suffix.ab0ae73.png";